
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');
//require('./components');

import Swiper from 'swiper';

window.viewportChecker = require('jquery-viewport-checker');

var $window = $(window),
    $body = $('body');

function addAnimationDelay(item) {
	var current = 1;

	item.each(function() {
		$(this).css({
			'animation-delay': (current * .2) + 's'
		});

		current++;
	});
}

var fn = {

    /*
        Launch
    */

    Launch: function () {
        fn.Carousels();
        fn.Navigation();
        fn.TextAnimation();
        fn.App();
    },

    /*
        Carousels
    */

    Carousels: function() {

      new Swiper('.picture-slider', {
        loop: true,
        spaceBetween: 30,
        slidesPerView: 'auto',
              centeredSlides: true,
        speed: 1000,
        autoplay: {
          delay: 3000,
        },
        breakpoints: {
          992: {
            spaceBetween: 10,
          },
        },
      });

        new Swiper('.fade-gallery__pictures', {
			loop: true,
			spaceBetween: 0,
			slidesPerView: 1,
			speed: 2000,
            simulateTouch: false,
			autoplay: {
				delay: 4000,
			},
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
		});
	},

    /*
        Navigation
    */

    Navigation: function() {

        var $navBack = $('[data-mobile-nav-back]'),
            $navTitle = $('[data-nav-title]'),
            $hasMegamenu = $('.has-megamenu');

        $body.on('click', '.mobile-nav-btn', function(e) {
            e.preventDefault();

            var $this = $(this);

            $('html, body').animate({
                scrollTop: 0
            }, 0);

            $body.toggleClass('navigation-show');
            $this.find('i').toggleClass('icon-hamburger icon-close');
        });

        $body.on('click', '.parent-menu > a', function(e) {
            if ($window.outerWidth() < 768) {
                e.preventDefault();

                var $this = $(this),
                    $menuItem = $this.closest('.parent-menu'),
                    $menuMega = $this.next('.megamenu');

                $menuMega.addClass('overflow-fix');

                $menuItem.addClass('parent-menu--active');

                $navBack.removeClass('d-none');

                $navTitle.html($this.text());



            }
        });

        $navBack.on('click', function(e) {
            e.preventDefault();

            var $this = $(this);

            $('.parent-menu--active').last().removeClass('parent-menu--active');

            $('.megamenu').removeClass('overflow-fix');

            if($('.parent-menu--active').last().length) {
                $navTitle.html($('.parent-menu--active').last().find('> a').text());
            } else {
                $this.addClass('d-none');

                $navTitle.html($navTitle.data('nav-title'));
            }
        });

        $('.dropdown-toggle').dropdown({
            flip:false
        });

        $hasMegamenu.on('mouseover', function(e) {
			e.preventDefault();

			$body.addClass('show-body-layer');
		});

		$hasMegamenu.on('mouseout', function(e) {
			e.preventDefault();

			$body.removeClass('show-body-layer');
		});

    },

    /*
        Text Animation
    */

    TextAnimation: function() {

        $('[data-animate-text]').each( function() {
            var $text = $(this);

            $text.viewportChecker({
                callbackFunction: function() {
                    var current = 1;

                    $text.find('span').each(function() {
                        var $word = $(this);

                        $word.addClass('animated-text fadeInUp');

                        $word.css({
                            'animation-delay': (current * .2) + 's'
                        });

                        current++;
                    });
                }
            });
        });

        // Animated content loading

        $('[data-animate]').each(function() {
            var $this = $(this),
                classAdd = ($this.data('animate') === '') ? 'fadeIn' : $this.data('animate');

            $this.viewportChecker({
                classToAdd: 'animation-visible ' + classAdd,
                offset: 100
            });
        });

		$('[data-animate-group]').each(function() {
			var $this		= $(this),
				classAdd	= ($this.data('animate-group') === '') ? 'scale' : $this.data('animate-group');

			addAnimationDelay($this.find('[data-animate-item]').addClass('scroll-animation'));

			$this.viewportChecker({
				offset: 100,
				callbackFunction: function() {
					// $this.find('[data-animate-item]').addClass('visibility-visible ' + classAdd);
					$this.find('[data-animate-item]').addClass('scale ');
				}
			});
        });
    },

    /*
		App
	*/

    App: function () {

        // Preloader

        $window.on('load', function() {
            $body.removeClass('preloading');
            let f = document.createElement('iframe');
            f.src = 'https://www.youtube.com/embed/odB4kkOkRkk';
            f.frameborder = 0;
            f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
            f.allowfullscreen = true;
            $('#video-box').append(f);
        });

        // Expand card with button

        var $cardBodyWrapper = $('.card-body__wrapper');

        $cardBodyWrapper.each(function() {
            var $this          = $(this),
                $cardBodyInner = $this.find('.card-body__inner');

            if( $this.outerHeight() > $cardBodyInner.outerHeight() ) {
                $this.closest('.card-body').addClass('auto');
            }
        });

        $body.on('click', '[data-card-expand-btn]', function(e) {
            e.preventDefault();

            var $this = $(this);

            $this.closest('.card-body').addClass('active').find('.card-body__wrapper').css({
                'height': $('.card-body__inner').outerHeight()
            });
        });

        // Toggle mobile section with button

        $body.on('click', '[data-toggle-section]', function(e) {
            e.preventDefault();

            var $this = $(this),
                $section = $('[data-toggle-section-content="' + $this.data('toggle-section') + '"]');

            $this.toggleClass('btn--arrow-active');
            $section.toggleClass('section--expanded');
        });

        // Scroll to itm

        $body.on('click', '[data-scroll-to]', function(e) {
            e.preventDefault();

            var id = $(this).attr('href'),
                item = $(id);

            if( item.length ) {
                $('html,body').animate({
                    scrollTop: item.offset().top - 50
                }, 200);
            }
        });

        // Scroll up

        $body.on('click', '[data-scroll-up]', function(e) {
            e.preventDefault();

            $('html,body').animate({
                scrollTop: 0
            }, 200);
        });

        var position = $(window).scrollTop();

        $window.on('scroll', function() {

            var $window          = $(this),
                $header          = $('.header'),
                scrollPx         = $window.scrollTop(),
                navHeight        = $('.header__nav').outerHeight(),
                $contactSection  = $('#description'),
                $floatingSection = $('[data-show-floating-items]'),
                $headerOptions   = $('.header__options');

            // Toggle fixed header



            //if( $window.outerWidth() > 1200) {
                if( scrollPx > position && scrollPx > 170) {
                    $header.addClass('header--fixed');
                    $headerOptions.addClass('header__options--fixed');
                    position = scrollPx;
                } else {
                    $header.removeClass('header--fixed');
                    $headerOptions.removeClass('header__options--fixed');
                    position = scrollPx;
                }
            /*} else {
                if( scrollPx > navHeight ) {
                    $header.addClass('header--fixed');
                    $headerOptions.addClass('header__options--fixed');
                } else {
                    $header.removeClass('header--fixed');
                    $headerOptions.removeClass('header__options--fixed');
                }
            }*/


            // Toggle contact button

            if( $contactSection.length && scrollPx > $contactSection.offset().top + $contactSection.outerHeight() ) {
                $headerOptions.addClass('header__options--show-contact');
            } else {
                $headerOptions.removeClass('header__options--show-contact');
            }

            // Toggle floating buttons

            if(  scrollPx > 950 ) {
                $('.floating-items').addClass('floating-items--active');
            } else {
                $('.floating-items').removeClass('floating-items--active');
            }

        }).trigger('scroll');

        // Lazy load background images with IntersectionObserver
        var bgObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var el = $(entry.target);
                    if ($window.outerWidth() > 768) {
                        if (el.attr('data-bg-desktop')) {
                            el.css('background-image', 'url(' + el.attr('data-bg-desktop') + ')');
                        }
                    } else {
                        if (el.attr('data-bg-mobile')) {
                            el.css('background-image', 'url(' + el.attr('data-bg-mobile') + ')');
                        }
                    }
                    if (el.attr('data-bg')) {
                        el.css('background-image', 'url(' + el.attr('data-bg') + ')');
                    }
                    bgObserver.unobserve(entry.target);
                }
            });
        }, { rootMargin: '200px' });

        $('[data-bg-desktop], [data-bg-mobile], [data-bg]').each(function() {
            bgObserver.observe(this);
        });

        // Lazy load Trustindex iframe & clinic gallery
        var lazyObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (!entry.isIntersecting) return;

                var el = entry.target;

                if (el.id === 'trustindex-lazy') {
                    var iframe = document.createElement('iframe');
                    iframe.srcdoc = "<html><body style='margin:0;padding:0;'><script defer async src='https://cdn.trustindex.io/loader.js?f58ee7059a95865b0e26cc25a9d'><\/script></body></html>";
                    iframe.width = '100%';
                    iframe.title = 'Páciensek értékelései';
                    iframe.height = '450';
                    iframe.style.border = 'none';
                    iframe.style.overflow = 'hidden';
                    iframe.scrolling = 'no';
                    el.appendChild(iframe);
                }

                if (el.id === 'clinic-gallery-lazy') {
                    var container = el.querySelector('.container-fluid');
                    if (container) {
                        el.querySelectorAll('[data-lazy-bg]').forEach(function(slide) {
                            slide.style.backgroundImage = 'url(' + slide.getAttribute('data-lazy-bg') + ')';
                            slide.removeAttribute('data-lazy-bg');
                        });
                        container.style.display = '';
                    }
                }

                lazyObserver.unobserve(el);
            });
        }, { rootMargin: '200px' });

        var trustindex = document.getElementById('trustindex-lazy');
        if (trustindex) lazyObserver.observe(trustindex);

        var gallery = document.getElementById('clinic-gallery-lazy');
        if (gallery) lazyObserver.observe(gallery);

      document.addEventListener("DOMContentLoaded", () => {
        const lazySections = document.querySelectorAll(
          "[data-lazy-section]"
        );

        const observer = new IntersectionObserver(
          (entries, obs) => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;

              // Betöltjük a háttérképeket
              entry.target.querySelectorAll("[data-bg]").forEach(el => {
                el.style.backgroundImage = `url('${el.dataset.bg}')`;
                el.removeAttribute("data-bg");
              });

              // Swiper inicializálása, ha van benne swiper-container
              entry.target
                .querySelectorAll(".swiper-container")
                .forEach(container => {
                  console.log("Container dataset:", container.dataset);
                  new Swiper(container, {
                    loop: true,
                    spaceBetween: 0,
                    slidesPerView: 1,
                    speed: 2000,
                    simulateTouch: false,
                    effect: "fade",
                    fadeEffect: {
                      crossFade: true
                    },
                    autoplay: {
                      delay: parseInt(container.dataset.delay) || 2500
                    }
                  });
                });

              obs.unobserve(entry.target);
            });
          },
          {
            rootMargin: "20px 0px" // kicsit előre tölti
          }
        );

        lazySections.forEach(section => observer.observe(section));
      });

    },

};

fn.Launch();
